import axios from 'axios'

export default {
    getVisitor(){
        return axios.get('/visitor')
            .then(response => {
                return response.data
            })
    },
    getVisitorDataSource(params){
        return axios.get('/visitor/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getVisitorbyID(id){
        return axios.get('/visitor/' + id)
            .then(response => {
                return response.data
            })
    },    
    createVisitor(formdata){
        return axios.post('/visitor', formdata)
            .then(response => {
                return response.data
            })
    },
    updateVisitor(id,formdata){
        return axios.put('/visitor/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deleteVisitor(id){
        return axios.delete('/visitor/' + id + '')
            .then(response => {
                return response.data
            })
    },
    deactivateVisitor(id){
        return axios.put('/visitor/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
}